import { returnStatuses } from '@reveni-io/reveni-ui'

export const getTextForWhenIssueExchange = (t, issueRefundAtStatus, storeName) => {
  const texts = {
    [returnStatuses.shipped]: t('una vez envíes tu devolución'),
    [returnStatuses.received]: t('cuando {{storeName}} reciba tu devolución', { storeName }),
    [returnStatuses.accepted]: t('cuando {{storeName}} valide tu devolución', { storeName }),
  }

  return texts[issueRefundAtStatus]
}
